export const formatForUrl = (str) => {
  if (typeof str !== 'string') {
    return ''; // Return an empty string or handle it as needed
  }
  
  return str
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
};